export default {
    //folder
    folder: require('./images/folder.png'),
    folderChild: require('./images/folder4.png'),
    advertiser: require('./images/advertiser.png'),
    folderHasChild: require('./images/folderHasChild.png'),
    folderOpen: require('./images/folderOpen.png'),
    notification: require('./images/notification.png'),
    speaker: require('./images/speaker.png'),
    iconRecord: require('./images/icon-record.png'),
    iconLiveRead: require('./images/iconLiveRead.png'),
    iconAdvertiser: require('./images/icon-advertiser.png'),
    liveRead: require('./images/live-read.png'),
    preRecord: require('./images/pre-record.png'),
    liveReadActive: require('./images/live-readActive.png'),
    preRecordActive: require('./images/pre-recordActive.png'),
    logo: require('./images/logo.png'),
    megaphone: require('./images/megaphone.png'),
    watchlists: require('./images/watchlists.png'),
    watchlistsActive: require('./images/watchlistsActive.png'),
    logoVeritone: require('./images/logoVeritone.png'),
    logoVeritoneFooter: require('./images/logoVeritoneFooter.png'),
    connectionFailed: require('./images/connectionFailed.png'),
    connectionSuccess: require('./images/connectionSuccess.png'),
    inviteLogo: require('./images/inviteLogo.png'),
    user: require('./images/user.png'),
    mail: require('./images/mail.png'),
    phone: require('./images/phone.png'),
    gaLogo: require('./images/gaLogo.png'),
    browserUpload: require('./images/browserUpload.png'),
    browseUpload: require('./images/browseUpload.png'),
    facebook: require('./images/facebook.png'),
    googleAnalytics: require('./images/googleAnalytics.png'),
    iconAdvertiserName: require('./images/iconAdvertiserName.png'),
    iconCampaignName: require('./images/iconCampaignName.png'),
    iconCalendar: require('./images/iconCalendar.png'),
    notFound: require('./images/image-not-found.png'),
    defaultMediaImage: require("./images/defaultMediaImage.png"),
    nullLocationGeoFence: require("./images/null-location.svg"),
    attributeBackground: require("./images/attribute-background.png"),
    veritoneLogo: require("./images/veritone-logo.png"),
    veritoneLogoNewFont: require('./images/veritoneLogoNewFont.svg'),
    megaphoneInviteIcon: require("./images/megaphone-icon.png"),
    manageConnections: require("./images/icon-manage-connections.svg"),
    manageConnectionsSuccess: require("./images/icon-manage-connections-success.svg"),
    searchAdvertiserIcon: require("./images/advertiser.svg"),
    searchCampaignIcon: require("./images/campaign.svg"),
    manageConnectionsAdvertiser: require("./images/image-manage-connections-advertiser.svg"),
    newMegaphoneIcon: require('./images/newMegaphoneIcon.svg'),
    newInformationIcon: require('./images/newInformationIcon.svg'),
    newCalendarIcon: require('./images/newCalendarIcon.svg'),
    blueStationPlayoutIcon: require('./images/blueStationPlayoutIcon.svg'),
    whiteInfoIcon: require('./images/whiteInfoIcon.svg'),
    webAnalyticsChart: require('./images/webAnalyticsChart.png'),
    barChart: require('./images/barChart.png'),
    locationMap: require('./images/locationMap.png'),
    disabledLocationMap: require('./images/disabledLocationMap.png'),
    dataTable: require('./images/dataTable.png'),
    pieChart: require('./images/pieChart.png'),
    disabledPieChart: require('./images/disabledPieChart.png'),
    timeOfDayChart: require('./images/timeOfDayChart.png'),
    playoutUploadExample: require('./images/playout_data_sample.png'),
    webDataExample: require('./images/web_analytics_sample.png'),
    webDataExampleWithNewUserSessions: require('./images/web-analytics-sample-with-new-user.png'),
    pptxNote: require('./images/pptxnote.png'),
}
